/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Member Contact Email Schema
 * @export
 * @interface MemberContactEmail
 */
export interface MemberContactEmail {
    /**
     * Member ID
     * @type {string}
     * @memberof MemberContactEmail
     */
    memberId: string;
    /**
     * Order
     * @type {number}
     * @memberof MemberContactEmail
     */
    order: number;
    /**
     * Email
     * @type {string}
     * @memberof MemberContactEmail
     */
    email: string;
    /**
     * Created Date
     * @type {Date}
     * @memberof MemberContactEmail
     */
    createdDate: Date;
    /**
     * Updated Date
     * @type {Date}
     * @memberof MemberContactEmail
     */
    updatedDate: Date;
}

/**
 * Check if a given object implements the MemberContactEmail interface.
 */
export function instanceOfMemberContactEmail(value: object): value is MemberContactEmail {
    if (!('memberId' in value) || value['memberId'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined) return false;
    return true;
}

export function MemberContactEmailFromJSON(json: any): MemberContactEmail {
    return MemberContactEmailFromJSONTyped(json, false);
}

export function MemberContactEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberContactEmail {
    if (json == null) {
        return json;
    }
    return {
        
        'memberId': json['member_id'],
        'order': json['order'],
        'email': json['email'],
        'createdDate': (new Date(json['created_date'])),
        'updatedDate': (new Date(json['updated_date'])),
    };
}

export function MemberContactEmailToJSON(value?: MemberContactEmail | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'member_id': value['memberId'],
        'order': value['order'],
        'email': value['email'],
        'created_date': ((value['createdDate']).toISOString()),
        'updated_date': ((value['updatedDate']).toISOString()),
    };
}

